export const css = {
	root: '_2i3mJyNN',
	content: '_38GZBapK',
	bottom: 'kAxkX4k9',
	top: '_1KcTtru2',
	left: 'hfN_FJdq',
	right: '_2oqgngIZ',
	' _key': 'ascm-theme/dojo/tooltip'
};

export default css;
